export default "__VITE_ASSET__40a9953e__"